import type { ReactNode } from 'react';
import './Dialog.css';

export function Dialog({ open, onClose, title, children, footer, wide }: {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  footer?: ReactNode;
  wide?: boolean;
}) {
  if (!open) return null;
  return (
    <div className="nb-dialog" role="dialog" aria-modal onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className={`nb-dialog__panel ${wide ? 'nb-dialog__panel--wide' : ''}`}>
        <header className="nb-dialog__head">
          <h2>{title}</h2>
          <button onClick={onClose} aria-label="close">×</button>
        </header>
        <div className="nb-dialog__body">{children}</div>
        {footer && <footer className="nb-dialog__foot">{footer}</footer>}
      </div>
    </div>
  );
}
